import React from 'react';

interface WalletIconProps {
  size?: number;
  color?: string;
}

const WalletIcon: React.FC<WalletIconProps> = ({
  size = 40,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.94979 4.61833L23.1797 9.8C24.415 10.2057 25.4939 10.9847 26.2677 12.0295C27.0414 13.0743 27.4719 14.3335 27.4997 15.6333V33.15C27.5517 33.703 27.4682 34.2603 27.2565 34.7738C27.0447 35.2873 26.711 35.7417 26.2844 36.0972C25.8577 36.4528 25.3509 36.6992 24.8075 36.815C24.2644 36.9307 23.701 36.9125 23.1664 36.7617L8.08646 32.6617C6.85103 32.2773 5.76781 31.514 4.99013 30.48C4.21243 29.446 3.77968 28.1935 3.75313 26.9V7.81333C3.72574 6.6027 4.17824 5.43037 5.01189 4.55207C5.84554 3.67377 6.99271 3.16077 8.20313 3.125H31.2497C32.5759 3.125 33.8477 3.65178 34.7854 4.58947C35.723 5.52715 36.2497 6.79892 36.2497 8.125V23.0467C36.2439 23.7208 36.105 24.387 35.8412 25.0073C35.5774 25.6277 35.1937 26.1898 34.7122 26.6617C34.2305 27.1333 33.6607 27.5055 33.035 27.7567C32.4095 28.0077 31.7405 28.133 31.0664 28.125H27.4997"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.625 23.125C20.2798 23.125 20 22.8452 20 22.5C20 22.1548 20.2798 21.875 20.625 21.875"
      stroke={color}
      strokeWidth="2"
    />
    <path
      d="M20.625 23.125C20.9702 23.125 21.25 22.8452 21.25 22.5C21.25 22.1548 20.9702 21.875 20.625 21.875"
      stroke={color}
      strokeWidth="2.5"
    />
    <path
      d="M36.25 15.625H27.5"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WalletIcon;